import { useMemo } from "react";
import { useLocation } from "react-router";

import { useGetNodeIdExists } from "../nodes/useGetNodeIdExists.ts";

export const useContextPathIds = () => {
  const { pathname } = useLocation();
  return pathname
    .split("/")
    .map(Number)
    .filter((s) => !isNaN(s));
};

export const useContextPathNodeIds = () => {
  const getNodeIdExists = useGetNodeIdExists();
  const ids = useContextPathIds();

  return useMemo(() => ids.filter(getNodeIdExists), [getNodeIdExists, ids]);
};

// bit quirky but via useBreadcrumbs didn't work as mutates during render
// Can sometimes be undefined in between renders during navigation.
export const useContextNodeId = (): number | undefined => {
  const nodeIds = useContextPathNodeIds();
  return nodeIds[nodeIds.length - 1];
};

export const useContextId = () => {
  const ids = useContextPathIds();
  return ids[ids.length - 1] ?? 0;
};
